import { BaseEntity } from "../../../Api/Types/baseTypes";
import { GenericSearchFormProps } from "../../Shared/Components/SearchFormWrapper";
import { IdNameDto } from "../../Shared/Types/common";
import type { InvoiceScheme } from "../../Invoices/Types/invoicesTypes";

export interface Offer extends BaseEntity {
  id: number;
  name: string;
  hotelName?: string;
  countryName?: string;
  categoryNames?: string[];
  published: boolean;
  description: string;
  priceIncludes?: string;
  additionalPaid?: string;
  importantInformation?: string;
  metaTitle: string;
  metaDescription: string;
  metaKeywords: string;
  regionId?: number | null;
  hotelId?: number | null;
  countryId?: number | null;
  displayOrder?: number;
  slug?: string;
  shortDescription?: string;
  offerTypeId?: number;
  offerCategoryId?: number;
  offerCategoryIds?: number[];
  offerCategories?: IdNameDto[] | null;
  offerTagIds?: number[];
  offerTagId?: number;
  offerTags?: IdNameDto[] | null;
  offerOptions?: {
    offerOptionsTypeId: number;
    offerOptionsValueId: number;
  }[];
  companyId?: number | null;
  companyName?: string;
  /** Identifier of the image designated as the offer's main/hero image. */
  mainImageId?: string | null;
  /** Relative path of the main image (populated from with-associations endpoint). */
  mainImagePath?: string | null;
  /** Default invoice scheme propagated to new reservations. */
  defaultInvoiceScheme?: InvoiceScheme | null;
}
export interface OfferSearchFilters {
	searchTerm: string;
	categoryId: string;
	hotelId: string;
	countryId: string;
	regionId: string;
	companyId: string;
	published: string;
}
export type OfferSearchFormProps = GenericSearchFormProps<OfferSearchFilters>;
export interface OfferFiltersDto {
	hotels: IdNameDto[];
	categories: IdNameDto[];
	countries: IdNameDto[];
	regions: IdNameDto[];
	companies: IdNameDto[];
	publishedOptions: IdNameDto[];
}

export interface OfferListRequest {
	searchTerm?: string;
	categoryId?: number;
	hotelId?: number;
	countryId?: number;
	regionId?: number;
	companyId?: number;
	onlyPublished?: boolean;
	pageNumber?: number;
	pageSize?: number;
}

export const offerCloneSections = [
	'basic',
	'additionalInformation',
	'seo',
	'configuration',
	'categories',
	'tags',
	'offerOptions',
	'program',
	'boardingPlaces',
	'images',
] as const;

export type OfferCloneSection = (typeof offerCloneSections)[number];

export interface CloneOfferRequest {
	sectionsToCopy: OfferCloneSection[];
}

export interface CloneOfferResponse {
	id: number;
}
